import { ConcurrencyLimiter } from "./concurrencyLimiter";

type ConcurrencyRule = {
  match: (url: string) => boolean;
  limiter: ConcurrencyLimiter;
};

/**
 * Path-based concurrency rules. First matching rule wins.
 *
 * These limiters sit after deduplication in the request pipeline:
 * dedup → semaphore → fetch. Duplicate in-flight GETs never consume a slot.
 */
const rules: ConcurrencyRule[] = [
  {
    match: url => /\/observability\/resources\//.test(url),
    limiter: new ConcurrencyLimiter(1)
  },
  {
    match: url => /\/observability(\/|\?|$)/.test(url),
    limiter: new ConcurrencyLimiter(3)
  }
];

export const matchConcurrencyRule = (
  url: string
): ConcurrencyLimiter | undefined => rules.find(r => r.match(url))?.limiter;
